<template lang="pug">
    div
        button.change-button(
          :disabled="disabled || loading"
          @click="showModal = true"
        )
          b-spinner(v-if="loading" small)
          span {{ loading ? 'Procesando...' : 'Revaluar OT' }}
        
        b-modal(
          v-model="showModal"
          title="Confirmar Revaluación"
          @ok="confirmRevaluarOT"
          @cancel="showModal = false"
          @hidden="showModal = false"
        )
          template(#modal-footer="{ ok, cancel }")
            button.btn.btn-outline-danger.btn-sm(
              type="button"
              @click="cancel()"
            ) Cancelar
            button#btn-aceptar.btn.btn-button.btn-sm(
              type="button"
              @click="ok()"
              :disabled="loading"
            )
              b-spinner(v-if="loading" small)
              span {{ loading ? ' Procesando...' : ' Confirmar' }}
          
          p Esta acción revaluará la Orden de Trabajo actual. El sistema volverá a evaluar el estado y los criterios de la OT.
          p.text-warning.mt-2(v-if="isEnReparacion")
            b-icon(icon="exclamation-triangle-fill")
            |  Se cerrará la cotización actual y se creará una nueva con los mismos ítems y abonos.
          p 
            strong ¿Está seguro que desea continuar?
    </template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
    components: {},
    name: 'ActionRevaluarOT',
    mixins: [LoadingButtonMixin],
    props: ['ot', 'disabled'],

    computed: {
        isEnReparacion() {
            return this.ot?.estado?.estado?.nombre === 'En Reparación'
        },
    },

    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        ...mapActions('OTStore', ['revaluarOT']),

        async confirmRevaluarOT() {
            try {
                await this.executeWithLoading(async () => {
                    const response = await this.revaluarOT({ ot: this.ot.ot });
                    if (response.data.code !== 200) {
                         this.$bvToast.toast('Error al revaluar OT', {
                            variant: 'error',
                            title: 'Error',
                        })
                    }
                    if (response.data.code === 200) {
                        this.$bvToast.toast('OT revaluada con éxito', {
                            variant: 'success',
                            title: 'Éxito',
                        })
                    }
                })
            } catch (error) {
                console.error('Error al revaluar OT:', error)
                this.$bvToast.toast('Error al revaluar OT', {
                    variant: 'danger',
                })
            }
        }

    }
}
</script>
